import Vue from 'vue'
import {initializeApp} from 'firebase'
import firebase from 'firebase/app'
import 'firebase/firestore'

import VueFirestore from 'vue-firestore'
Vue.use(VueFirestore)

const config = {
    apiKey: "AIzaSyB4ivHmx7Xw8MaQ45bJTEtv3tEJLjYdaNE",
    authDomain: "emails-45321.firebaseapp.com",
    databaseURL: "https://emails-45321.firebaseio.com",
    projectId: "emails-45321",
    storageBucket: "emails-45321.appspot.com",
    messagingSenderId: "147034242993",
    appId: "1:147034242993:web:8961fd33896add1efd4790"
};

firebase.initializeApp(config)

export const db = firebase.firestore()